import { Currency } from './wallet';

export interface IVector3 {
	x: number;
	y: number;
	z: number;
}

export type IVector2 = Pick<IVector3, 'x' | 'y'>;

export enum GameplayActivityTimerIcon {
	RentCar = 'rent_car',
	Dead = 'dead',
	Job = 'job',
	Race = 'race',
	War = 'war',
	Flash = 'flash',
	PizzaBox = 'pizza_box',
	Box = 'box',
	Farm = 'farm',
	DrivingSchool = 'driving_school',
	None = 'none',
}

/** Таймер, связанный с геймплейной активностью игрока */
export interface IGameplayActivityTimer {
	/** Тип таймера (совпадает с названием иконки) */
	icon: GameplayActivityTimerIcon;
	/** Длительность таймера в милисекундах */
	duration: number;
}

export enum GameplayJobProgressIcon {
	Plant = 'plant',
	Delivery = 'delivery',
	Passenger = 'passenger',
	Station = 'station',
	MailBox = 'mail_box',
	PowerFix = 'power_fix',
	Apple = 'apple',
	Pizza = 'pizza',
	Group = 'group',
}

export interface IGameplayJobProgress {
	icon: GameplayJobProgressIcon;
	counter: number;
	counterWordForms: [string, string, string];
	currencyIcon: Currency;
	currencyAmount: number;
}
